import _ from 'lodash';
import {
  Prime100CoverageGroups,
  Prime100Coverages,
} from '../workflows/quotes/prime-100/types';

const baseStates = ['NY', 'WA'];
export const calculateCoverageOptions = (
  {
    businessIncomeCoverage,
    ransomPaymentLimit,
    hardwareReplCostEndorsement,
    hardwareReplCostSubLimit,
    telecomsFraudEndorsement,
    telecomsFraudSubLimit,
    postBreachRemediationEndorsement,
    postBreachRemediationSubLimit,
    computerFraudEndorsement,
    websiteMediaContentLiabilityEndorsement,
    websiteMediaContentLiabilitySubLimit,
    limit,
    socialEngLimit,
    additionalInsureds,
    isTriaExcluded,
    enhancedBusinessAndCbi,
    enhancedBusinessAndCbiWithSystemFailure,
    reverseSocialEngineeringEndorsement,
    reverseSocialEngineeringLimit,
    reverseSocialEngineeringDeductible,
    dedicatedBreachCostsEndorsementSubLimit,
    serviceFraudAndCryptojackingSubLimit,
  }: any,
  {
    onChange = null,
    register,
    onClick = null,
    socialEngEndorsement,
    coverageMapping,
    state,
    boostVersion,
  }: any = {}
) => [
  {
    id: Prime100Coverages.SECURITY_BREACH_EXPENSE,
    label:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.SECURITY_BREACH_EXPENSE.name,
    defaultChecked: true,
    percentage: 1,
    disabled: false,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.SECURITY_BREACH_EXPENSE.tooltip,
    mandatory: true,
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: Prime100Coverages.RESTORATION_OF_ELECTRONIC_DATA,
    label:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.RESTORATION_OF_ELECTRONIC_DATA.name,
    defaultChecked: true,
    percentage: 1,
    disabled: false,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.RESTORATION_OF_ELECTRONIC_DATA.tooltip,
    mandatory: true,
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: Prime100Coverages.PUBLIC_RELATIONS_EXPENSE,
    label:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.PUBLIC_RELATIONS_EXPENSE.name,
    defaultChecked: true,
    percentage: baseStates.includes(state) ? 50000 / limit : 0.05,
    disabled: false,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.PUBLIC_RELATIONS_EXPENSE.tooltip,
    mandatory: true,
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: Prime100Coverages.EXTORTION_THREATS_AND_RANSOM_PAYMENT,
    label:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.EXTORTION_THREATS_AND_RANSOM_PAYMENT.name,
    defaultChecked: true,
    percentage: ransomPaymentLimit / limit,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.EXTORTION_THREATS_AND_RANSOM_PAYMENT.tooltip,
    disabled: false,
    mandatory: true,
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: 'ransomLimit',
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: Prime100Coverages.BI_EXTRA_EXPENSE,
    label: !_.isEmpty(coverageMapping) && coverageMapping.BI_EXTRA_EXPENSE.name,
    defaultChecked: true,
    disabled: false,
    percentage: businessIncomeCoverage / limit,
    tooltip:
      !_.isEmpty(coverageMapping) && coverageMapping.BI_EXTRA_EXPENSE.tooltip,
    mandatory: true,
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: 'sublimit',
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: Prime100Coverages.ENHANCED_BUSINESS_AND_CONTINGENT_BUSINESS_INCOME,
    name: 'enhancedBusinessAndCbi',
    label: 'E-Commerce Enhancement',
    checked: !!enhancedBusinessAndCbi,
    mandatory: false,
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.ENHANCED_BUSINESS_AND_CONTINGENT_BUSINESS_INCOME.tooltip,
  },
  {
    id: Prime100Coverages.ENHANCED_BUSINESS_AND_CONTINGENT_BUSINESS_INCOME_SYSTEM_FAILURE_INCLUSIVE,
    name: 'enhancedBusinessAndCbiWithSystemFailure',
    label: 'E-Commerce Enhancement & System Failure',
    checked: !!enhancedBusinessAndCbiWithSystemFailure,
    mandatory: false,
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping
        .ENHANCED_BUSINESS_AND_CONTINGENT_BUSINESS_INCOME_SYSTEM_FAILURE_INCLUSIVE
        .tooltip,
  },
  {
    id: Prime100Coverages.COMPUTER_FUNDS_TRANSFER_FRAUD,
    name: 'computerFraudEndorsement',
    label:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.COMPUTER_FUNDS_TRANSFER_FRAUD.name,
    defaultChecked: !!computerFraudEndorsement,
    percentage: !computerFraudEndorsement ? 0 : 1,
    onChange,
    checked: !!computerFraudEndorsement,
    disabled: !_.isEmpty(coverageMapping),
    register,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.COMPUTER_FUNDS_TRANSFER_FRAUD.tooltip,
    mandatory: false,
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: Prime100Coverages.SOCIAL_ENGINEERING,
    label:
      !_.isEmpty(coverageMapping) && coverageMapping.SOCIAL_ENGINEERING.name,
    checked: socialEngEndorsement,
    defaultChecked: socialEngEndorsement,
    percentage: socialEngLimit / limit,
    onChange,
    onClick,
    modalName: 'SocialEngg',
    register,
    disabled: !_.isEmpty(coverageMapping),
    tooltip:
      !_.isEmpty(coverageMapping) && coverageMapping.SOCIAL_ENGINEERING.tooltip,
    mandatory: false,
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: 'socialLimit',
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: 'socialDeductible',
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: Prime100Coverages.REVERSE_SOCIAL_ENGINEERING_ENDORSEMENT,
    label:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.REVERSE_SOCIAL_ENGINEERING_ENDORSEMENT.name,
    checked: reverseSocialEngineeringEndorsement,
    defaultChecked: reverseSocialEngineeringEndorsement,
    percentage: reverseSocialEngineeringLimit / limit,
    register,
    disabled: !_.isEmpty(coverageMapping),
    tooltip:
      !_.isEmpty(coverageMapping) && coverageMapping.SOCIAL_ENGINEERING.tooltip,
    mandatory: false,
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: 'reverseSocialEngineeringLimit',
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: 'reverseSocialEngineeringDeductible',
    groupName: Prime100CoverageGroups.FIRST_PARTY_COVERAGES,
  },
  {
    id: Prime100Coverages.PCI_FINES_AND_PENALTIES,
    label:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.PCI_FINES_AND_PENALTIES.name,
    defaultChecked: true,
    percentage: 1,
    disabled: false,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.PCI_FINES_AND_PENALTIES.tooltip,
    mandatory: true,
    groupName: Prime100CoverageGroups.THIRD_PARTY_COVERAGES,
  },
  {
    id: Prime100Coverages.REGULATOR_DEFENSE_AND_PENALTIES,
    label:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.REGULATOR_DEFENSE_AND_PENALTIES.name,
    defaultChecked: true,
    percentage: 1,
    disabled: false,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.REGULATOR_DEFENSE_AND_PENALTIES.tooltip,
    mandatory: true,
    groupName: Prime100CoverageGroups.THIRD_PARTY_COVERAGES,
  },
  {
    id: Prime100Coverages.SECURITY_BREACH_LIABILITY,
    label:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.SECURITY_BREACH_LIABILITY.name,
    defaultChecked: true,
    percentage: 1,
    disabled: false,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.SECURITY_BREACH_LIABILITY.tooltip,
    mandatory: true,
    groupName: Prime100CoverageGroups.THIRD_PARTY_COVERAGES,
  },
  {
    id: Prime100Coverages.WEBSITE_MEDIA_CONTENT_LIABILITY,
    name: 'websiteMediaContentLiabilityEndorsement',
    label:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.WEBSITE_MEDIA_CONTENT_LIABILITY.name,
    defaultChecked: websiteMediaContentLiabilityEndorsement,
    percentage: websiteMediaContentLiabilitySubLimit / limit,
    onChange,
    register,
    disabled: !_.isEmpty(coverageMapping),
    checked: websiteMediaContentLiabilityEndorsement,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.WEBSITE_MEDIA_CONTENT_LIABILITY.tooltip,
    mandatory: false,
    groupName: Prime100CoverageGroups.THIRD_PARTY_COVERAGES,
  },

  {
    id: 'websiteLimit',
    groupName: Prime100CoverageGroups.THIRD_PARTY_COVERAGES,
  },
  {
    id: Prime100Coverages.HARDWARE_REPLACEMENT_COSTS,
    name: 'hardwareReplCostEndorsement',
    label:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.HARDWARE_REPLACEMENT_COSTS.name,
    defaultChecked: hardwareReplCostEndorsement,
    percentage: !hardwareReplCostEndorsement
      ? 0
      : hardwareReplCostSubLimit / limit,
    onChange,
    register,
    disabled: !_.isEmpty(coverageMapping),
    checked: hardwareReplCostEndorsement,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.HARDWARE_REPLACEMENT_COSTS.tooltip,
    mandatory: false,
    groupName: Prime100CoverageGroups.ENDORSEMENTS,
  },

  {
    id: Prime100Coverages.TELECOM_FRAUD,
    name: 'telecomsFraudEndorsement',
    label: !_.isEmpty(coverageMapping) && coverageMapping.TELECOM_FRAUD.name,
    defaultChecked: telecomsFraudEndorsement,
    percentage: !telecomsFraudEndorsement ? 0 : telecomsFraudSubLimit / limit,
    onChange,
    register,
    disabled: !_.isEmpty(coverageMapping),
    checked: telecomsFraudEndorsement,
    tooltip:
      !_.isEmpty(coverageMapping) && coverageMapping.TELECOM_FRAUD.tooltip,
    mandatory: false,
    groupName: Prime100CoverageGroups.ENDORSEMENTS,
  },
  {
    id: Prime100Coverages.POST_BREACH_REMEDIATION,
    name: 'postBreachRemediationEndorsement',
    label:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.POST_BREACH_REMEDIATION.name,
    defaultChecked: postBreachRemediationEndorsement,
    percentage: !postBreachRemediationEndorsement
      ? 0
      : postBreachRemediationSubLimit / limit,
    onChange,
    register,
    disabled: !_.isEmpty(coverageMapping),
    checked: postBreachRemediationEndorsement,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.POST_BREACH_REMEDIATION.tooltip,
    mandatory: false,
    groupName: Prime100CoverageGroups.ENDORSEMENTS,
  },
  {
    id: Prime100Coverages.DEDICATED_BREACH_COSTS_ENDORSEMENT,
    name: 'dedicatedBreachCostsEndorsementSubLimit',
    label: 'Dedicated Breach Costs',
    checked: !!dedicatedBreachCostsEndorsementSubLimit,
    mandatory: false,
    groupName: Prime100CoverageGroups.ENDORSEMENTS,
    percentage: dedicatedBreachCostsEndorsementSubLimit / limit,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.DEDICATED_BREACH_COSTS_ENDORSEMENT.tooltip,
  },
  {
    id: Prime100Coverages.SERVICE_FRAUD_AND_CRYPTOJACKING,
    name: 'serviceFraudAndCryptojackingSubLimit',
    label: 'Service Fraud and Cryptojacking',
    checked: !!serviceFraudAndCryptojackingSubLimit,
    mandatory: false,
    groupName: Prime100CoverageGroups.ENDORSEMENTS,
    percentage: serviceFraudAndCryptojackingSubLimit / limit,
    tooltip:
      !_.isEmpty(coverageMapping) &&
      coverageMapping.SERVICE_FRAUD_AND_CRYPTOJACKING.tooltip,
  },
  {
    id: Prime100Coverages.ADDITIONAL_INSURED,
    name: 'additionalInsureds',
    label: 'Additional Insured',
    register,
    onChange,
    checked: additionalInsureds,
    disabled: false,
    mandatory: false,
    groupName: Prime100CoverageGroups.ENDORSEMENTS,
  },
  {
    id: Prime100Coverages.TRIA,
    name: 'isTriaExcluded',
    label: !_.isEmpty(coverageMapping) && coverageMapping.TRIA.name,
    checked: !isTriaExcluded,
    mandatory: false,
    groupName: Prime100CoverageGroups.TRIA,
  },
];

export const waitingPeriods = {
  6: '6 Hours',
  8: '8 Hours',
  12: '12 Hours',
  24: '24 Hours',
};

export const retroActivePeriods = {
  1: '1 Year',
  2: '2 Years',
  3: 'Full Prior Acts',
};
